function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
import includes from 'lodash/includes';
import sortBy from 'lodash/sortBy';
import find from 'lodash/find';
import NcsFilter from './NcsFilter';
export default {
  extends: NcsFilter,
  props: {
    allowEmpty: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    values: function values() {
      var values = this.$store.getters['filters/possibleValues'](this.id);
      return this.allowEmpty && !includes(values, null) ? [null].concat(_toConsumableArray(values)) : values;
    },
    options: function options() {
      var options = this.addLabels(this.values);

      if (this.$ncsConfig.filters.sortBy[this.id]) {
        options = sortBy(options, this.$ncsConfig.filters.sortBy[this.id]);
      }

      return options;
    },
    isDisabled: {
      get: function get() {
        // Besides the NcsFilter conditions, select will be disabled if there is only the null option available
        return this.$store.getters['filters/isDisabled'](this.id) || this.requireParents && this.$store.getters['filters/parentsEmpty'](this.id) || this.options.length === 1 && this.options[0] === null;
      },
      set: function set(disabled) {
        this.$store.commit('filters/setDisabled', {
          id: this.id,
          disabled: disabled
        });
      }
    }
  },
  methods: {
    addLabels: function addLabels(values) {
      var _this = this;

      return values.map(function (v) {
        return {
          label: _this.$tOr("filters.".concat(_this.id, ".options"), v),
          value: v
        };
      });
    }
  }
};